<template>
  <div class="levo__user">
    <div class="levo__user__picture">
      <div class="levo__user__picture__wrapper">
        <div class="levo__user__picture__wrapper--img"></div>
      </div>

      <div class="levo__user__picture__bell">
        <div class="levo__user__picture__bell__wrapper">
          <div class="levo__user__picture__bell__wrapper--img"></div>
        </div>

        <div class="levo__user__picture__bell__notification"></div>
      </div>
    </div>

    <UserDetails />
  </div>
</template>

<script>
import UserDetails from "@/components/game/user/UserDetails.vue";
export default {
  name: "LevoUser",
  components: {
    UserDetails,
  },
};
</script>